/* Clover theme — vanilla JS, no dependencies */
(function () {
  'use strict';

  const T = window.theme || {};
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => Array.from(el.querySelectorAll(s));

  /* ---------- Helpers ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || T.moneyFormat || '${{amount}}';
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const fmt = (n, precision, thousands = ',', decimal = '.') => {
      if (isNaN(n) || n == null) return '0';
      n = (n / 100.0).toFixed(precision);
      const parts = n.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      const c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    };
    const match = format.match(placeholder);
    let value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(placeholder, value);
  }
  window.theme.formatMoney = formatMoney;

  let toastTimer;
  function toast(msg) {
    const el = $('#Toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2600);
  }

  function lockScroll(lock) { document.body.classList.toggle('no-scroll', lock); }

  async function fetchJSON(url, body) {
    const res = await fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || T.strings.error);
    return data;
  }

  /* ---------- Cart ---------- */
  const Cart = {
    drawer: null,

    init() {
      this.drawer = $('#CartDrawer');
      document.addEventListener('click', (e) => {
        const opener = e.target.closest('[data-cart-open]');
        if (opener && this.drawer) { e.preventDefault(); this.open(); }
        if (e.target.closest('[data-cart-close]')) { e.preventDefault(); this.close(); }

        const minus = e.target.closest('[data-qty-minus]');
        const plus = e.target.closest('[data-qty-plus]');
        if (minus || plus) {
          const wrap = (minus || plus).closest('.qty');
          const input = $('input', wrap);
          const min = parseInt(input.min || '0', 10);
          let v = parseInt(input.value || '0', 10) + (plus ? 1 : -1);
          if (v < min) v = min;
          input.value = v;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }

        const remove = e.target.closest('[data-line-remove]');
        if (remove) { e.preventDefault(); this.change(remove.dataset.lineRemove, 0, remove.closest('.line')); }

        const quick = e.target.closest('[data-quick-add]');
        if (quick) {
          e.preventDefault();
          this.add([{ id: Number(quick.dataset.quickAdd), quantity: 1 }], quick);
        }
      });

      document.addEventListener('change', (e) => {
        const input = e.target.closest('[data-line-qty]');
        if (input) this.change(input.dataset.lineQty, parseInt(input.value, 10) || 0, input.closest('.line'));
        const note = e.target.closest('[data-cart-note]');
        if (note) fetchJSON(T.routes.cartUpdate + '.js', { note: note.value }).catch(() => {});
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.drawer && this.drawer.classList.contains('is-open')) this.close();
      });

      this.loadRecommendations(document);
    },

    open() {
      if (!this.drawer) return;
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      lockScroll(true);
      const closeBtn = $('[data-cart-close].icon-btn', this.drawer);
      if (closeBtn) setTimeout(() => closeBtn.focus(), 50);
    },

    close() {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      lockScroll(false);
    },

    sectionIds() {
      const ids = [];
      if ($('#CartDrawer')) ids.push('cart-drawer');
      $$('[data-cart-section]').forEach((el) => ids.push(el.dataset.cartSection));
      return ids;
    },

    async refresh() {
      const ids = this.sectionIds();
      const cart = await fetchJSON(T.routes.cart + '.js');
      $$('[data-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
        el.classList.toggle('hidden', cart.item_count === 0);
      });
      if (!ids.length) return cart;
      const res = await fetch(`${window.location.pathname}?sections=${ids.join(',')}`);
      const sections = await res.json();
      ids.forEach((id) => {
        const html = sections[id];
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        if (id === 'cart-drawer') {
          const fresh = $('[data-drawer-inner]', doc);
          const current = $('[data-drawer-inner]', this.drawer);
          if (fresh && current) current.replaceWith(fresh);
          this.loadRecommendations(this.drawer);
        } else {
          const fresh = $(`[data-cart-section="${id}"]`, doc);
          const current = $(`[data-cart-section="${id}"]`);
          if (fresh && current) current.replaceWith(fresh);
          this.loadRecommendations(document);
        }
      });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
      return cart;
    },

    async add(items, button) {
      if (button) button.classList.add('is-loading');
      try {
        await fetchJSON(T.routes.cartAdd + '.js', { items });
        if (T.cartType === 'page' || !this.drawer) {
          window.location.href = T.routes.cart;
          return;
        }
        await this.refresh();
        this.open();
      } catch (err) {
        toast(err.message);
        throw err;
      } finally {
        if (button) button.classList.remove('is-loading');
      }
    },

    async change(key, quantity, lineEl) {
      if (lineEl) lineEl.classList.add('is-loading');
      try {
        await fetchJSON(T.routes.cartChange + '.js', { id: key, quantity });
        await this.refresh();
      } catch (err) {
        toast(err.message);
        if (lineEl) lineEl.classList.remove('is-loading');
      }
    },

    async loadRecommendations(root) {
      const el = $('[data-cart-recs]', root);
      if (!el || el.dataset.loaded) return;
      el.dataset.loaded = 'true';
      try {
        const res = await fetch(el.dataset.cartRecs);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const list = $('[data-recs-items]', doc);
        if (!list || !list.children.length) { el.remove(); return; }
        const inCart = (el.dataset.inCart || '').split(',');
        $$('[data-product-id]', list).forEach((item) => { if (inCart.includes(item.dataset.productId)) item.remove(); });
        const max = parseInt(el.dataset.limit || '0', 10);
        if (max) $$('[data-product-id]', list).slice(max).forEach((item) => item.remove());
        if (!list.children.length) { el.remove(); return; }
        $('[data-recs-target]', el).replaceWith(list);
        el.classList.remove('hidden');
      } catch (e) { el.remove(); }
    }
  };

  /* ---------- Product ---------- */
  class Product {
    constructor(root) {
      this.root = root;
      this.form = $('form[data-product-form]', root);
      this.idInput = this.form ? $('input[name="id"]', this.form) : null;
      const json = $('[data-variants-json]', root);
      this.variants = json ? JSON.parse(json.textContent) : [];
      this.picker = $('[data-variant-picker]', root);
      this.atc = $('[data-atc]', root);
      this.sticky = $('[data-sticky-atc]', root);
      this.bindForm();
      this.bindPicker();
      this.initGallery();
      this.initSticky();
      this.initShare();
      $$('[data-bundle]', root).forEach((el) => new Bundle(el));
    }

    currentVariant() {
      if (!this.idInput) return null;
      return this.variants.find((v) => String(v.id) === String(this.idInput.value)) || this.variants[0];
    }

    bindForm() {
      if (!this.form) return;
      this.form.addEventListener('submit', (e) => {
        if (T.cartType === 'page' && !$$('[data-addon-input]:checked', this.root).length) return; // native submit
        e.preventDefault();
        const qtyInput = $('input[name="quantity"]', this.form);
        const items = [{ id: Number(this.idInput.value), quantity: qtyInput ? Number(qtyInput.value) || 1 : 1 }];
        $$('[data-addon-input]:checked', this.root).forEach((c) => items.push({ id: Number(c.value), quantity: 1 }));
        const err = $('[data-form-error]', this.root);
        if (err) err.classList.add('hidden');
        Cart.add(items, this.atc).catch((ex) => {
          if (err) { err.textContent = ex.message; err.classList.remove('hidden'); }
        });
      });
    }

    bindPicker() {
      if (!this.picker) return;
      this.picker.addEventListener('change', () => {
        const selected = $$('fieldset, .variant-picker__select', this.picker).map((group) => {
          const checked = $('input:checked', group);
          if (checked) return checked.value;
          const sel = group.tagName === 'SELECT' ? group : $('select', group);
          return sel ? sel.value : null;
        });
        const variant = this.variants.find((v) => v.options.every((o, i) => o === selected[i]));
        $$('[data-selected-option]', this.picker).forEach((el, i) => { el.textContent = selected[i] || ''; });
        this.updateVariant(variant);
      });
    }

    updateVariant(variant) {
      const btnLabel = this.atc ? $('[data-atc-label]', this.atc) : null;
      if (!variant) {
        if (this.atc) this.atc.disabled = true;
        if (btnLabel) btnLabel.textContent = T.strings.unavailable;
        return;
      }
      this.idInput.value = variant.id;
      if (this.atc) this.atc.disabled = !variant.available;
      if (btnLabel) btnLabel.textContent = variant.available ? T.strings.addToCart : T.strings.soldOut;
      $$('[data-price]', this.root).forEach((el) => this.renderPrice(el, variant));
      if (this.root.dataset.updateUrl !== 'false') {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
      if (variant.featured_media) this.goToMedia(variant.featured_media.id);
      $$('[data-bundle]', this.root).forEach((b) => b.dispatchEvent(new CustomEvent('variant:change', { detail: variant })));
    }

    renderPrice(el, v) {
      const onSale = v.compare_at_price && v.compare_at_price > v.price;
      let html = `<span class="${onSale ? 'price__sale' : 'price__regular'}">${formatMoney(v.price)}</span>`;
      if (onSale) {
        html += `<s class="price__compare">${formatMoney(v.compare_at_price)}</s>`;
        if (el.dataset.showSave !== undefined) {
          const pct = Math.round(((v.compare_at_price - v.price) / v.compare_at_price) * 100);
          html += `<span class="badge badge--sale">${el.dataset.saveLabel ? el.dataset.saveLabel.replace('[percent]', pct) : '-' + pct + '%'}</span>`;
        }
      }
      el.innerHTML = html;
    }

    initGallery() {
      const g = $('[data-gallery]', this.root);
      if (!g) return;
      this.slides = $('[data-gallery-slides]', g);
      const slides = $$('[data-media-id]', this.slides);
      const thumbs = $$('[data-thumb]', g);
      const dots = $$('[data-dot]', g);
      const go = (i) => {
        i = Math.max(0, Math.min(slides.length - 1, i));
        this.slides.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      };
      this.goToMedia = (mediaId) => {
        const i = slides.findIndex((s) => s.dataset.mediaId === String(mediaId));
        if (i > -1) go(i);
      };
      thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
      dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
      const prev = $('[data-gallery-prev]', g);
      const next = $('[data-gallery-next]', g);
      const index = () => Math.round(this.slides.scrollLeft / this.slides.clientWidth);
      if (prev) prev.addEventListener('click', () => go(index() - 1));
      if (next) next.addEventListener('click', () => go(index() + 1));
      let raf;
      this.slides.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const i = index();
          thumbs.forEach((t, n) => t.classList.toggle('is-active', n === i));
          dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
        });
      });
    }

    goToMedia() {}

    initSticky() {
      if (!this.sticky || !this.atc || !('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver(([entry]) => {
        const passed = entry.boundingClientRect.top < 0;
        this.sticky.classList.toggle('is-visible', !entry.isIntersecting && passed);
      });
      io.observe(this.atc);
      const btn = $('[data-sticky-submit]', this.sticky);
      if (btn) btn.addEventListener('click', () => {
        if (this.picker && this.variants.length > 1) {
          this.form.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else if (this.form.requestSubmit) {
          this.form.requestSubmit();
        } else {
          this.form.dispatchEvent(new Event('submit', { cancelable: true }));
        }
      });
    }

    initShare() {
      const btn = $('[data-share]', this.root);
      if (!btn) return;
      btn.addEventListener('click', async () => {
        const url = btn.dataset.share;
        if (navigator.share) {
          try { await navigator.share({ title: document.title, url }); } catch (e) {}
        } else if (navigator.clipboard) {
          await navigator.clipboard.writeText(url);
          toast(btn.dataset.copied || 'Link copied');
        }
      });
    }
  }

  /* ---------- Frequently bought together ---------- */
  // Savings follow the store-wide bundle tiers (Theme settings > Cart),
  // which should mirror the automatic discounts set up in Shopify admin.
  class Bundle {
    constructor(el) {
      this.el = el;
      try { this.tiers = JSON.parse(el.dataset.tiers || '[]').sort((a, b) => a.qty - b.qty); } catch (e) { this.tiers = []; }
      this.button = $('[data-bundle-add]', el);
      el.addEventListener('change', () => this.update());
      el.addEventListener('variant:change', (e) => {
        const main = $('[data-bundle-main]', el);
        const v = e.detail;
        if (!main || !v) return;
        main.dataset.variantId = v.id;
        main.dataset.price = v.price;
        main.dataset.compare = v.compare_at_price || v.price;
        const p = $('[data-bundle-item-price]', main.closest('.bundle__item'));
        if (p) { p.dataset.base = v.price; p.dataset.compare = v.compare_at_price || v.price; }
        this.update();
      });
      if (this.button) this.button.addEventListener('click', () => this.addToCart());
      this.update();
    }

    checked() { return $$('input[data-variant-id]:checked', this.el); }

    pctFor(n) {
      let pct = 0;
      this.tiers.forEach((t) => { if (n >= t.qty) pct = t.pct; });
      return pct;
    }

    update() {
      const items = this.checked();
      const pct = this.pctFor(items.length);
      let total = 0, compare = 0;
      items.forEach((i) => {
        const price = Number(i.dataset.price);
        total += price;
        compare += Math.max(Number(i.dataset.compare || price), price);
      });
      const final = Math.round(total * (1 - pct / 100));
      $$('[data-bundle-item-price]', this.el).forEach((p) => {
        const base = Number(p.dataset.base);
        const was = Math.max(Number(p.dataset.compare || base), base);
        const now = Math.round(base * (1 - pct / 100));
        p.innerHTML = formatMoney(now) + (was > now ? `<s>${formatMoney(was)}</s>` : '');
      });
      const set = (sel, v) => { const x = $(sel, this.el); if (x) x.textContent = v; };
      set('[data-bundle-total]', formatMoney(final));
      set('[data-bundle-compare]', compare > final ? formatMoney(compare) : '');
      const badge = $('[data-bundle-badge]', this.el);
      if (badge) { badge.textContent = pct ? `-${pct}%` : ''; badge.classList.toggle('hidden', !pct); }
      const s = $('[data-bundle-save]', this.el);
      if (s) {
        const saved = compare - final;
        s.textContent = saved > 0 ? (s.dataset.template || 'You save [amount]').replace('[amount]', formatMoney(saved)) : '';
      }
      if (this.button) this.button.disabled = items.length === 0;
    }

    addToCart() {
      const items = this.checked().map((i) => ({ id: Number(i.dataset.variantId), quantity: 1 }));
      if (items.length) Cart.add(items, this.button).catch(() => {});
    }
  }

  /* ---------- Bundle builder ---------- */
  class Builder {
    constructor(el) {
      this.el = el;
      this.min = parseInt(el.dataset.min || '3', 10);
      this.max = parseInt(el.dataset.max || '5', 10);
      this.tiers = JSON.parse($('[data-builder-tiers]', el).textContent || '[]').sort((a, b) => a.qty - b.qty);
      this.selected = [];
      this.button = $('[data-builder-add]', el);
      el.addEventListener('click', (e) => {
        const card = e.target.closest('[data-builder-card]');
        const toggle = e.target.closest('[data-builder-toggle]') || e.target.closest('.card__media');
        if (card && toggle) { e.preventDefault(); this.toggle(card); }
        const rm = e.target.closest('[data-builder-remove]');
        if (rm) {
          const card2 = $(`[data-builder-card][data-variant-id="${rm.dataset.builderRemove}"]`, el);
          if (card2) this.toggle(card2);
        }
      });
      if (this.button) this.button.addEventListener('click', () => {
        const items = this.selected.map((s) => ({ id: Number(s.id), quantity: 1 }));
        if (items.length >= this.min) Cart.add(items, this.button).catch(() => {});
      });
      this.render();
    }

    toggle(card) {
      const id = card.dataset.variantId;
      const i = this.selected.findIndex((s) => s.id === id);
      if (i > -1) {
        this.selected.splice(i, 1);
      } else {
        if (this.selected.length >= this.max) { toast(this.el.dataset.maxMessage || 'Bundle is full'); return; }
        this.selected.push({ id, price: Number(card.dataset.price), img: card.dataset.image, title: card.dataset.title });
      }
      this.render();
    }

    tierFor(n) {
      let t = null;
      this.tiers.forEach((x) => { if (n >= x.qty) t = x; });
      return t;
    }

    render() {
      const n = this.selected.length;
      $$('[data-builder-card]', this.el).forEach((c) => {
        const on = this.selected.some((s) => s.id === c.dataset.variantId);
        c.classList.toggle('is-selected', on);
        const btn = $('[data-builder-toggle]', c);
        if (btn) btn.textContent = on ? btn.dataset.labelRemove : btn.dataset.labelAdd;
      });
      const slots = $('[data-builder-slots]', this.el);
      if (slots) {
        const count = Math.max(this.max, n);
        slots.style.setProperty('--slots', Math.min(count, 6));
        slots.innerHTML = '';
        for (let i = 0; i < count; i++) {
          const s = this.selected[i];
          const d = document.createElement('div');
          d.className = 'builder__slot' + (s ? ' is-filled' : '');
          d.innerHTML = s ? `<img src="${s.img}" alt="${s.title.replace(/"/g, '&quot;')}"><button type="button" data-builder-remove="${s.id}" aria-label="Remove">✕</button>` : `${i + 1}`;
          slots.appendChild(d);
        }
      }
      const total = this.selected.reduce((a, s) => a + s.price, 0);
      const tier = this.tierFor(n);
      const pct = tier ? tier.pct : 0;
      const final = Math.round(total * (1 - pct / 100));
      const set = (sel, v) => { const x = $(sel, this.el); if (x) x.innerHTML = v; };
      set('[data-builder-count]', n);
      set('[data-builder-total]', formatMoney(final));
      set('[data-builder-compare]', pct ? formatMoney(total) : '');
      const next = this.tiers.find((x) => x.qty > n);
      const msg = $('[data-builder-message]', this.el);
      if (msg) {
        if (next) msg.innerHTML = (msg.dataset.template || 'Add [count] more to save [percent]%').replace('[count]', next.qty - n).replace('[percent]', next.pct);
        else if (tier) msg.innerHTML = (msg.dataset.maxTemplate || 'You unlocked [percent]% off!').replace('[percent]', tier.pct);
      }
      if (this.button) {
        this.button.disabled = n < this.min;
        const lbl = $('[data-builder-btn-label]', this.button);
        if (lbl) lbl.textContent = n < this.min
          ? (this.button.dataset.labelMin || 'Pick [count] more').replace('[count]', this.min - n)
          : (this.button.dataset.labelReady || 'Add bundle to cart');
      }
    }
  }

  /* ---------- Header / menu / search ---------- */
  function initHeader() {
    const menu = $('#MobileMenu');
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-menu-open]') && menu) { menu.classList.add('is-open'); lockScroll(true); }
      if (e.target.closest('[data-menu-close]') && menu) { menu.classList.remove('is-open'); lockScroll(false); }
      const st = e.target.closest('[data-search-toggle]');
      if (st) {
        e.preventDefault();
        const panel = $('#HeaderSearch');
        if (panel) { panel.classList.toggle('hidden'); if (!panel.classList.contains('hidden')) $('input', panel).focus(); }
      }
      // close desktop dropdowns when clicking outside
      $$('.header__nav details[open]').forEach((d) => { if (!d.contains(e.target)) d.removeAttribute('open'); });
      const ft = e.target.closest('[data-facets-toggle]');
      if (ft) { const f = $('#Facets'); if (f) f.classList.toggle('is-open'); }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && menu && menu.classList.contains('is-open')) { menu.classList.remove('is-open'); lockScroll(false); }
    });
  }

  function initAnnouncement() {
    $$('[data-announcement]').forEach((bar) => {
      const items = $$('.announcement__item', bar);
      if (items.length < 2) return;
      let i = 0;
      const speed = parseInt(bar.dataset.speed || '5', 10) * 1000;
      setInterval(() => {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, speed);
    });
  }

  function initFacets() {
    const form = $('[data-facets-form]');
    if (form) {
      form.addEventListener('change', (e) => {
        if (e.target.type === 'number') return;
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
    $$('[data-sort]').forEach((sel) => sel.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    }));
  }

  function initRecommendations() {
    $$('[data-recommendations]').forEach(async (el) => {
      try {
        const res = await fetch(el.dataset.recommendations);
        const html = await res.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = $('[data-recommendations]', doc);
        if (fresh && fresh.innerHTML.trim().length) el.innerHTML = fresh.innerHTML;
        else el.closest('section') && el.closest('section').remove();
      } catch (e) {}
    });
  }

  function initProducts() {
    $$('[data-product]').forEach((el) => { if (!el.__product) el.__product = new Product(el); });
    $$('[data-builder]').forEach((el) => { if (!el.__builder) el.__builder = new Builder(el); });
  }

  document.addEventListener('DOMContentLoaded', () => {
    Cart.init();
    initHeader();
    initAnnouncement();
    initFacets();
    initProducts();
    initRecommendations();
  });

  // Theme editor support
  document.addEventListener('shopify:section:load', () => { initProducts(); initRecommendations(); initAnnouncement(); Cart.drawer = $('#CartDrawer'); });

  window.theme.Cart = Cart;
})();
